import { apiFetch } from './apiFetch';

async function getProfile(transgressorRef, token) {
  const url = `${process.env.REACT_APP_API_URL}/Visor/GetTansgressorProfile?transgressorRef=${transgressorRef}`;

  try {
    const response = await apiFetch(url, {
      method: 'GET',      
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
}

export default { getProfile };
